import { Route, Routes, BrowserRouter } from 'react-router-dom';
import Protected from './protectedRoutes';

//Pages
import LoginUser from '../pages/loginUser/loginUser';
import SignupUser from '../pages/signupUser/signupUser';
import Dashboard from '../pages/navbar/navbar';
import AuthenticateUser from '../pages/authenticationPage/authenticationPage';
import SiteRequest from '../pages/siteRequest/siteRequest';
import StaffProfile from '../pages/staffProfile/staffProfile';
import SponsorStudy from '../pages/sponsorStudy/sponsorStudy';
import SponsorForm from '../pages/sponsorForm/sponsorForm';
import ReadSponsorForm from '../pages/sponsorForm/readSponsorForm';
import WhyResearchMate from '../pages/whyResearchMate/whyResearchMate';
import StudyForm from '../pages/createStudy/createStudy';
import StudyCard from '../pages/studiesPage/studyPage';
import DevelopingStudyCard from '../pages/developingStudyCard/developingStudyCard';
import CloseStudyCard from '../pages/closeStudyCard/closeStudyCard';
import MyStudyCard from '../pages/myStudyCard/myStudyCard';
import ChartComponent from '../pages/dashboard/dashboard';
import Navbar from '../Components/Navbar';
import ActiveStudyCardForUser from '../pages/activeStudyCardForUser/activeStudyCardForUser';
import ActiveStudyFormUser from '../pages/activeStudyFormUser/activeStudyFormUser';
import MainStudy from '../pages/mainStudyForm/mainStudyForm';
import Sites from '../pages/sites/sites';
import ActiveStudyFormForUser from '../pages/ActiveStudyFormForUser/ActiveStudyFormForUser';
import Spinner from '../Components/Spinner';
import { useState } from 'react';


function Routing() {
    const [showSpinner, setShowSpinner] = useState(false)
    return (
        <BrowserRouter>
            {showSpinner && <Spinner />}
            <Navbar />
            <Routes>
                <Route path='/signin' element={<SignupUser setShowSpinner={setShowSpinner} />} />
                <Route path='/' element={<LoginUser setShowSpinner={setShowSpinner} />} />
                <Route path='/authentication' element={<Protected Component={AuthenticateUser} setShowSpinner={setShowSpinner} />} />
                <Route path='/home' element={<Protected Component={Dashboard} setShowSpinner={setShowSpinner} />} />
                <Route path='/siteRequest' element={<Protected Component={SiteRequest} setShowSpinner={setShowSpinner} />} />x
                <Route path='/staffProfile' element={<Protected Component={StaffProfile} setShowSpinner={setShowSpinner} />} />
                {/* Sponsor Study */}
                <Route path='/sponsorStudy' element={<Protected Component={SponsorStudy} setShowSpinner={setShowSpinner} />} />
                <Route path='/readSponsorForm/:id' element={<Protected Component={ReadSponsorForm} setShowSpinner={setShowSpinner} />} />
                <Route path='/sponsorForm' element={<SponsorForm setShowSpinner={setShowSpinner} />} />
                <Route path='/whyResearchMate' element={<WhyResearchMate />} />
                {/* Create Study */}
                <Route path='/createStudy/:id' element={<Protected Component={StudyForm} setShowSpinner={setShowSpinner} />} />
                {/* developing Study */}
                <Route path='/developingStudy' element={<Protected Component={DevelopingStudyCard} setShowSpinner={setShowSpinner} />} />
                {/* Close Study */}
                <Route path='/closeStudy' element={<Protected Component={CloseStudyCard} setShowSpinner={setShowSpinner} />} />
                {/* Active Study */}
                <Route path='/activeStudy' element={<Protected Component={StudyCard} setShowSpinner={setShowSpinner} />} />
                <Route path='/activeStudyForm/:id' element={<Protected Component={MainStudy} setShowSpinner={setShowSpinner} />} />
                {/* My Study */}
                <Route path='/myStudy' element={<Protected Component={ActiveStudyCardForUser} setShowSpinner={setShowSpinner} />} />
                <Route path='/myStudyForm/:id' element={<Protected Component={ActiveStudyFormUser} setShowSpinner={setShowSpinner} />} />
                {/* Dashboard */}
                <Route path='/dashboard' element={<Protected Component={ChartComponent} setShowSpinner={setShowSpinner} />} />
                {/* Sites */}
                <Route path='/sites' element={<Protected Component={Sites} setShowSpinner={setShowSpinner} />} />
            </Routes>
        </BrowserRouter>
    );
}

export default Routing;
